export enum AlertId
{
    OutdatedPosition = "outdated-position",
    OutdatedPlan = "outdated-plan",
    OutdatedWeather = "outdated-weather",
    PlanRecalculatedETAChange = "plan-recalculated-eta-change",
    PlanRecalculatedNewForecast = "plan-recalculated-new-forecast",
    PlanRecalculatedGeneric = "plan-recalculated-generic",
    HeavyWeather = "heavy-weather",
    ParametricRoll = "parametric-roll"
}

export interface VesselAlert
{
    id: AlertId|string;
    message: string;
}

export abstract class VesselAlertsModelBase extends EventTarget
{
    abstract getAlerts(imo: number): VesselAlert[];
    abstract getAlert(imo: number, alertId: AlertId): VesselAlert|null;
    abstract addAlert(imo: number, alert: VesselAlert): void;
    abstract removeAlert(imo: number, alertId: AlertId|string): void;
    abstract clearAlerts(imo: number): void;
}

let VesselAlertsModel: VesselAlertsModelBase|null = null;

function setVesselAlertsModel(model: VesselAlertsModelBase)
{
    VesselAlertsModel = model;
}

export { VesselAlertsModel, setVesselAlertsModel };
